import agentsReducer from './Agents/reducer';
import areaReducer from './Area/reducer';
import areasReducer from './Areas/reducer';
import flightProductsReducer from './FlightProducts/reducer';
import poiReducer from './Poi/reducer';
import serviceReducer from './Service/reducer';
import servicesReducer from './Services/reducer';
import userReducer from './User/reducer';
import usersReducer from './Users/reducer';

export default {
  agents        : agentsReducer,
  area          : areaReducer,
  areas         : areasReducer,
  flightProducts: flightProductsReducer,
  poi           : poiReducer,
  service       : serviceReducer,
  services      : servicesReducer,
  user          : userReducer,
  users         : usersReducer,
};
